
import React from "react";
import { Label } from "@/components/ui/label";

interface PostMetadataCategoriesProps {
  categories: string[];
  setCategories: (categories: string[]) => void;
}

const PostMetadataCategories: React.FC<PostMetadataCategoriesProps> = ({
  categories,
  setCategories,
}) => {
  // Available categories (can be expanded)
  const availableCategories = [
    { id: "elf-tips", name: "Elf Tips" },
    { id: "holiday-magic", name: "Holiday Magic" },
    { id: "christmas-traditions", name: "Christmas Traditions" },
    { id: "elf-stories", name: "Elf Stories" },
  ];

  return (
    <div className="space-y-2">
      <Label htmlFor="categories">Categories</Label>
      <div className="flex flex-wrap gap-2 border rounded-md p-3">
        {availableCategories.map((category) => (
          <div key={category.id} className="flex items-center">
            <input
              type="checkbox"
              id={`category-${category.id}`}
              checked={categories.includes(category.id)}
              onChange={(e) => {
                if (e.target.checked) {
                  setCategories([...categories, category.id]);
                } else {
                  setCategories(categories.filter((c) => c !== category.id));
                }
              }}
              className="mr-2"
            />
            <Label htmlFor={`category-${category.id}`} className="text-sm cursor-pointer">
              {category.name}
            </Label>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PostMetadataCategories;
